import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { Tables } from "@/lib/supabase/supabase_types_override";

/**
 * @constant queryKey ["organization_list", user_id]
 * @param {number} orgId - The ID of the organization to fetch.
 */

export function useGetOrganizationById(orgId?: Tables<'organisation'>['id'] | string) {
    return useQuery({
        ...queryKeys.organisation.details(orgId! as number),
        enabled: !!orgId && Number.isInteger(orgId),
    });
}